// src/pages/restaurant-tables/ContinentalCategories.jsx
import React from 'react';
import CategoryList from '../CategoryList';

const ContinentalCategories = () => {
  return <CategoryList locationKey="continental" />;
};

export default ContinentalCategories;